import { render, staticRenderFns } from "./RequestDetail.vue?vue&type=template&id=bcedc4ae&"
import script from "./RequestDetail.vue?vue&type=script&lang=js&"
export * from "./RequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports